import React, { useState, useContext, useEffect } from "react";
import "../../assets/scss/components/_nav.scss";
import { func } from "prop-types";
import { Link } from "react-router-dom";
import Login from "../../cws/containers/pages/login/Login";
import ApplicationUserContext from "../../contexts/ApplicationUserContext";
import DashboardContext from "../../contexts/DashboardContext";
import NavDataContext from "../../contexts/NavDataContext";
//import PowerBiDashboards from "./cws/containers/pages/Reports/PowerBiDashboards"
import EmbeddedReports from "../../cws/containers/pages/Reports/EmbeddedReports";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import BpmnEditor from "../../cws/containers/pages/WorkflowConfiguration/WorkFlowConfig";
import { MotionPhotosOffSharp } from "@mui/icons-material";


const Nav = ({ selectedMenu }) => {
  //const contextType=ApplicationUserContext;
  const { reportids } = useSelector((state) => state);
  let navigate = useNavigate();
  const userRoles = React.useContext(ApplicationUserContext);
  const nav = React.useContext(DashboardContext);
  let assignedWorkItemDetails = React.useContext(NavDataContext);
  const selectedSubprocess = sessionStorage.getItem("ProcessId");
  let defaultFilter =
    "wi.UploadDate between dateadd(day,-10,getdate()) and getdate()";
  let navDetails = "";
  const navactivityname = "";
  // NAV LINKS TOGGLE FUNCTION
  const navRef = React.useRef(null);
  const onToggleClick = (e) => {
    navRef.current.classList.toggle("active");
    modeRef.current.classList.remove("mini-mode");
  };

  const { REACT_APP_GETMENUCONFIGURATION } = process.env;
  const { REACT_APP_API_URL } = process.env;

  // SWICTH MINI MODE FUNCTION
  const modeRef = React.useRef(null);
  const currentURL = window.location.href;
  const [navMenu, setnavMenu] = useState([]);
  const [rows, setrow] = useState([]);
  const [selectedAssignWorkitems, setselectedAssignWorkitem] = useState({});
  const [PreProcessorDashboard, setPreProcessorDashboard] = useState(false);
  const [Processor, setProcessor] = useState(false);
  const [processorData, setprocessorData] = useState({});
  const [PostProcessing, setPostProcessor] = useState(false);
  const [Reviewer, setReviewer] = useState(false);
  const [BOT, setBOT] = useState(false);
  const [BOTPend, setBOTPend] = useState(false);
  const [ReReview, setReReview] = useState(false);
  const [PostReview, setPostReview] = useState(false);
  const [OPIExpert, setOPIExpert] = useState(false);
  const [Imagery, setImagery] = useState(false);
  const [Photoshop, setPhotoshop] = useState(false);
  const [PSO, setPSO] = useState(false);
  const [TestingPending, setTestingPending] = useState(false);
  const [TestingRejected, setTestingRejected] = useState(false);
  const [NextTesting, setNextTesting] = useState(false);
  const [BotProcessor, setBotProcessor] = useState(false);
  const [Rejected, setRejected] = useState(false);
  const [Pending, setPending] = useState(false);
  const [HourTesting, set2HourTesting] = useState(false);
  const [FirstApprover, setFirstApprover] = useState(false);
  const [SecondApprover, setSecondApprover] = useState(false);
  const [ApprovalCoordinator, setApprovalCoordinator] = useState(false);
  const [clientDashboard, setClientDashboard] = useState(false);
  const [clientExceptionDashboard, setClientExceptionDashboard] =
    useState(false);
  const [clientCompletedDashboard, setClientCompletedDashboard] =
    useState(false);
  const [VendorDashboard, setVendorDashboard] = useState(false);
  const [ClosedDashboard, setClosedDashboard] = useState(false);
  const [CllientExceptionDashboard, setCllientExceptionDashboard] =
    useState(false);
  const [CompletedDashboard, setCompletedDashboard] = useState(false);
  const [ExceptionDashboard, setExceptionDashboard] = useState(false);
  const [EXLExpertDashboard, setEXLExpertDashboard] = useState(false);
  const [FifthApproverDashboard, setFifthApproverDashboard] = useState(false);
  const [FourthApproverDashboard, setFourthApproverDashboard] = useState(false);
  const [PreReviewDashboard, setPreReviewDashboard] = useState(false);
  const [RequestorDashboard, setRequestorDashboard] = useState(false);
  const [ResolvedDashboard, setResolvedDashboard] = useState(false);
  const [TestExceptionDashboard, setTestExceptionDashboard] = useState(false);
  const [ThirdApproverDashboard, setThirdApproverDashboard] = useState(false);
  const [
    VendorCommunicationDashboard,
    setVendorCommunicationDashboard
  ] = useState(false);
  const [VendorMaintenanceDashboard, setVendorMaintenanceDashboard] = useState(
    false
  );
  const [MenuConfig, setMenuConfig] = useState([]);
  
  const [openAdmin, setOpenAdmin] = useState(false);
  const [openActivities, setOpenActivities] = useState(false);
  const [businessRules, setbusinessRules] = useState(false);
  const [openConfiguration, setOpenConfiguration] = useState(false);
  const [openManageUsers, setOpenManageUsers] = useState(false);
  const [openReport, setOpenReport] = useState(false);
  const [openUpdateProfile, setOpenUpdateProfile] = useState(false);
  const [getselectMenu, setgetselectMenu] = useState([]);

  const [selection, serSelection] = useState([]);
  const [mainMenus, setmainMenus] = useState([]);
  const [admin, setAdmin] = useState(
    sessionStorage.getItem("is_admin") == "true" ? true : false
  );
  const [superadmin, setSuperadmin] = useState(
    sessionStorage.getItem("is_superadmin") == "true" ? true : false
  );
  const [OneandDone, setOneandDone] = useState(
    sessionStorage.getItem("is_OneandDone") == "true" ? true : false
  );
  const [upload, setUpload] = useState(
    sessionStorage.getItem("is_upload") == "true" ? true : false
  );
  const [activities, setActivities] = useState(
    sessionStorage.getItem("is_activities") == "true" ? true : false
  );
  const [client, setClient] = useState(
    sessionStorage.getItem("is_client") == "true" ? true : false
  );
  const [exceptions, setExceptions] = useState(
    sessionStorage.getItem("is_exceptions") == "true" ? true : false
  );
  const [complete, setComplete] = useState(
    sessionStorage.getItem("is_complete") == "true" ? true : false
  );
  const [vendor, setVendor] = useState(
    sessionStorage.getItem("is_vendor") == "true" ? true : false
  );
  const [workFlowstatechange, setWorkFlowstatechange] = useState(
    sessionStorage.getItem("is_workFlowstatechange") == "true" ? true : false
  );
  const [reassignment, setReassignment] = useState(
    sessionStorage.getItem("is_reassignment") == "true" ? true : false
  );
  const [adhocEditing, setAdhocEditing] = useState(
    sessionStorage.getItem("is_adhocEditing") == "true" ? true : false
  );
  const [undoActivity, setUndoActivity] = useState(
    sessionStorage.getItem("is_undoActivity") == "true" ? true : false
  );
  const [clientDailyInfo, setClientDailyInfo] = useState(
    sessionStorage.getItem("is_clientDailyInfo") == "true" ? true : false
  );
  const [workitemBulkUpdation, setWorkitemBulkUpdation] = useState(
    sessionStorage.getItem("is_workitemBulkUpdation") == "true" ? true : false
  );
  const [cwsRestrictedSearch, setCwsRestrictedSearch] = useState(
    sessionStorage.getItem("is_cwsRestrictedSearch") == "true" ? true : false
  );
  const [report, setReport] = useState(
    sessionStorage.getItem("is_report") == "true" ? true : false
  );
  const [manageUsers, setManageUsers] = useState(
    sessionStorage.getItem("is_manageUsers") == "true" ? true : false
  );
  const [workItemFieldadmin, setWorkItemFieldadmin] = useState(
    sessionStorage.getItem("is_workItemFieldadmin") == "true" ? true : false
  );
  const [Configuration, setConfiguration] = useState(
    sessionStorage.getItem("is_Configuration") == "true" ? true : false
  );
  const [UserClassificationMapping, setis_UserClassificationMapping] = useState(
    sessionStorage.getItem("is_UserClassificationMapping") == "true"
      ? true
      : false
  );
  const [UserClassificationList, setUserClassificationList] = useState(
    sessionStorage.getItem("is_UserClassificationList") == "true" ? true : false
  );
  const [WorkitemFieldsRules, setWorkitemFieldsRules] = useState(
    sessionStorage.getItem("is_WorkitemFieldsRules") == "true" ? true : false
  );
  const [instructionauthor, setInstructionauthor] = useState(
    sessionStorage.getItem("is_instructionauthor") == "true" ? true : false
  );
  const [instructionapprover, setInstructionapprover] = useState(
    sessionStorage.getItem("is_instructionapprover") == "true" ? true : false
  );
  const [CWSSearch, setCWSSearch] = useState(
    sessionStorage.getItem("is_search") == "true" ? true : false
  );
  const [manageWorkItems, setmanageWorkItems] = useState(
    sessionStorage.getItem("is_manageWorkItems") == "true" ? true : false
  );
  const [UploadandAssignment, setUploadandAssignment] = useState(
    sessionStorage.getItem("is_UploadandAssignment") == "true" ? true : false
  );
  const [QueueManagement, setQueueManagement] = useState(
    sessionStorage.getItem("is_QueueManagement") == "true" ? true : false
  );
  const [BucketManagement, setBucketManagement] = useState(
    sessionStorage.getItem("is_BucketManagement") == "true" ? true : false
  );
  const [RealTimeDashboard, setRealTimeDashboard] = useState(
    sessionStorage.getItem("is_RealTimeDashboard") == "true" ? true : false
  );

  const [imageryQA, setImageryQA] = useState(false);
  const [rejectedResolved, setRejectedResolved] = useState(false);

  let row = [];
  let selectedAssignWorkitem = {};
  useEffect(() => {
    setnavMenu(nav);
    sessionStorage.setItem("activityName", "");
    sessionStorage.setItem("workflowstateId", "");
    if (nav.length == 0) {
      setClientDashboard(false);
      setClientExceptionDashboard(false);
      setClientCompletedDashboard(false);
      setProcessor(false);
      setPreProcessorDashboard(false);
      setPostProcessor(false);
      setReviewer(false);
      setBOT(false);
      setBOTPend(false);
      setReReview(false);
      setPostReview(false);
      setOPIExpert(false);
      setImagery(false);
      setPhotoshop(false);
      setPSO(false);
      setTestingPending(false);
      setTestingRejected(false);
      setRejected(false);
      setPending(false);
      set2HourTesting(false);
      setNextTesting(false);
      setBotProcessor(false);
      setFirstApprover(false);
      setSecondApprover(false);
      setApprovalCoordinator(false);
      setVendorDashboard(false);
      setClosedDashboard(false);
      setCllientExceptionDashboard(false);
      setCompletedDashboard(false);
      setExceptionDashboard(false);
      setEXLExpertDashboard(false);
      setFifthApproverDashboard(false);
      setFourthApproverDashboard(false);
      setPreReviewDashboard(false);
      setRequestorDashboard(false);
      setResolvedDashboard(false);
      setTestExceptionDashboard(false);
      setThirdApproverDashboard(false);
      setVendorCommunicationDashboard(false);
      setVendorMaintenanceDashboard(false);
      setImageryQA(false);
      setRejectedResolved(false);
    } else {
      for (let i = 0; i < navMenu.length; i++) {
        if (navMenu[i].activityName === "Client") {
          setClientDashboard(true);
        }

        if (navMenu[i].activityName === "Client(Exception)") {
          setClientExceptionDashboard(true);
        }

        if (navMenu[i].activityName === "Client(Completed)") {
          setClientCompletedDashboard(true);
        }

        if (navMenu[i].activityName === "Processing") {
          setProcessor(true);
        }

        if (navMenu[i].activityName === "PreProcessing") {
          setPreProcessorDashboard(true);
        }

        if (navMenu[i].activityName === "PostProcessing") {
          setPostProcessor(true);
        }

        if (navMenu[i].activityName === "Reviewer") {
          setReviewer(true);
        }

        if (navMenu[i].activityName === "BOT") {
          setBOT(true);
        }

        if (navMenu[i].activityName === "BOT Pend") {
          setBOTPend(true);
        }

        if (navMenu[i].activityName === "ReReview") {
          setReReview(true);
        }

        if (navMenu[i].activityName === "PostReview") {
          setPostReview(true);
        }

        if (navMenu[i].activityName === "OPIExpert") {
          setOPIExpert(true);
        }

        if (navMenu[i].activityName === "First Approver") {
          setFirstApprover(true);
        }

        if (navMenu[i].activityName === "Imagery") {
          setImagery(true);
        }

        if (navMenu[i].activityName.toLowerCase() === "photoshop") {
          setPhotoshop(true);
        }

        if (navMenu[i].activityName === "PSO") {
          setPSO(true);
        }

        if (navMenu[i].activityName.toLowerCase() === "testing pending") {
          setTestingPending(true);
        }

        if (navMenu[i].activityName === "Testing Rejected") {
          setTestingRejected(true);
        }

        if (navMenu[i].activityName === "Pending") {
          setPending(true);
        }

        if (navMenu[i].activityName === "Rejected") {
          setRejected(true);
        }

        if (navMenu[i].activityName === "2 Hour Testing") {
          set2HourTesting(true);
        }
        if (navMenu[i].activityName.toLowerCase() === "nexttesting") {
          setNextTesting(true);
        }
        if (navMenu[i].activityName.toLowerCase() === "bot processor") {
          setBotProcessor(true);
        }

        if (navMenu[i].activityName === "Second Approver") {
          setSecondApprover(true);
        }

        if (navMenu[i].activityName === "Approval Coordinator") {
          setApprovalCoordinator(true);
        }

        if (navMenu[i].activityName === "Vendor") {
          setVendorDashboard(true);
        }

        if (navMenu[i].activityName === "Closed") {
          setClosedDashboard(true);
        }

        if (navMenu[i].activityName === "Cllient Exception") {
          setCllientExceptionDashboard(true);
        }

        if (navMenu[i].activityName === "Completed") {
          setCompletedDashboard(true);
        }

        if (navMenu[i].activityName === "Exception") {
          setExceptionDashboard(true);
        }

        if (navMenu[i].activityName === "EXLExpert") {
          setEXLExpertDashboard(true);
        }

        if (navMenu[i].activityName === "Fifth Approver") {
          setFifthApproverDashboard(true);
        }

        if (navMenu[i].activityName === "Fourth Approver") {
          setFourthApproverDashboard(true);
        }

        if (navMenu[i].activityName === "PreReview") {
          setPreReviewDashboard(true);
        }

        if (navMenu[i].activityName === "Requestor") {
          setRequestorDashboard(true);
        }

        if (navMenu[i].activityName === "Resolved") {
          setResolvedDashboard(true);
        }

        if (navMenu[i].activityName === "Test Exception") {
          setTestExceptionDashboard(true);
        }

        if (navMenu[i].activityName === "Third Approver") {
          setThirdApproverDashboard(true);
        }

        if (navMenu[i].activityName === "Vendor Communication") {
          setVendorCommunicationDashboard(true);
        }

        if (navMenu[i].activityName === "Vendor Maintenance") {
          setVendorMaintenanceDashboard(true);
        }
        if (navMenu[i].activityName === "Imagery QA") {
          setImageryQA(true);
        }
        if (navMenu[i].activityName === "Rejected Resolved") {
          setRejectedResolved(true);
        }
      }
    }

    //onModeClick()
  });
  useEffect(() => {
    setTimeout(() => {
      GetPriortyForSubProcess();
    }, 2000);
    modeRef.current.classList.toggle("mini-mode");
    // let MenuConfiguration=[]
    // MenuConfiguration=sessionStorage.getItem("MenuConfiguration");
    // if(MenuConfiguration == null || MenuConfiguration.length==0 || MenuConfiguration=="[]")
    // {
    //   // alert(11);
    //   setTimeout(() => {
    //     GetPriortyForSubProcess();
    //   }, 3000);
    //   // window.location.reload();
    // }
  }, []);
  const NavData = (navMenu) => {
    debugger;
    sessionStorage.setItem(
      "assignedWorkItemDetails",
      JSON.stringify(assignedWorkItemDetails)
    );
    sessionStorage.setItem("navMenu", navMenu);
    onModeClick();
    // if (
    //   navMenu.includes("Processing") ||
    //   navMenu.includes("Client") ||
    //   navMenu.includes("Completed") ||
    //   navMenu.includes("Exception") ||
    //   navMenu.includes("Reviewer")
    // ) {
    //   //navigateToWorkActivityDashboard();
    // }
  };
  // const navigateToWorkActivityDashboard = () => {
  //   navigate(
  //     "/WorkActivityDashboard",
  //     {state :{
  //       row,
  //       selectedSubprocess,
  //       nav,
  //       userRoles,
  //       defaultFilter,
  //       assignedWorkItemDetails,
  //     }}
  //   );
  // };
  const toggleAdmin = () => {
    setOpenAdmin(!openAdmin);
    modeRef.current.classList.remove("mini-mode");
  };
  const toggleActivities = (e) => {
    debugger;
    let TotalMenus=mainMenus;
    if(getselectMenu==TotalMenus.filter(m=>m.MainMenu===e.MainMenu)[0].MainMenu)
    {
      setgetselectMenu([]);
    }
    else
    {
      setgetselectMenu(TotalMenus.filter(m=>m.MainMenu===e.MainMenu)[0].MainMenu);
    }
    setOpenActivities(!openActivities);
    modeRef.current.classList.remove("mini-mode");
  };
  const toggleModel = () => {
    debugger;
    setgetselectMenu([]);
    // setOpenActivities(!openActivities);
    modeRef.current.classList.remove("mini-mode");
  };
  const toggleBusinessRules = () => {
    setbusinessRules(!businessRules);
    modeRef.current.classList.remove("mini-mode");
  };

  const toggleConfiguration = () => {
    setOpenConfiguration(!openConfiguration);
    modeRef.current.classList.remove("mini-mode");
  };
  const toggleManageUsers = () => {
    setOpenManageUsers(!openManageUsers);
    modeRef.current.classList.remove("mini-mode");
  };
  const toggleReport = () => {
    setOpenReport(!openReport);
    modeRef.current.classList.remove("mini-mode");
  };
  const toggleUpdateProfile = () => {
    setOpenUpdateProfile(!openUpdateProfile);
    modeRef.current.classList.remove("mini-mode");
  };

  const onModeClick = (e) => {
    modeRef.current.classList.toggle("mini-mode");
    if (openActivities) toggleModel();
    if (openActivities) setOpenActivities(!openActivities);
    if (businessRules) setbusinessRules(!businessRules);
    if (openAdmin) setOpenAdmin(!openAdmin);
    if (openConfiguration) setOpenConfiguration(!openConfiguration);
    if (openManageUsers) setOpenManageUsers(!openManageUsers);
    if (openReport) setOpenReport(!openReport);
    if (openUpdateProfile) setOpenUpdateProfile(!openUpdateProfile);
  };
  const backToHome = () => {
    navigate("/Home");
  };
  const getAPIURL = (api) => {
    let apiURL = REACT_APP_API_URL;
    return `${apiURL}${api}`;
  };
  // let mainMenus = [{mainMenu:"Activities"}]
  const GetPriortyForSubProcess = () => {
    let MenuConfiguration=[]
    MenuConfiguration=sessionStorage.getItem("MenuConfiguration");
    // alert(MenuConfiguration.length);
    let employeeid=""
    if(sessionStorage.getItem("PersonType")=="Employee")
    {
      employeeid=sessionStorage.getItem("HRISEmployeeID")
    }
    else
    {
      employeeid=sessionStorage.getItem("UserName")
    }
    // debugger;
    if(MenuConfiguration == null || MenuConfiguration.length==0 || MenuConfiguration=="[]")
    {
      sessionStorage.setItem("MenuConfiguration",[])
      sessionStorage.setItem("Menudetails",[])
      // alert(1);
      let body = {
        applicationname: sessionStorage.getItem("ApplicationURL"),
        employeeid: employeeid,
        subprocessID: sessionStorage.getItem("ProcessId"),
        personID: sessionStorage.getItem("PersonID")
      };
      let activityUrl = getAPIURL(REACT_APP_GETMENUCONFIGURATION);
      let req = new Request(`${activityUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          UserName: sessionStorage.getItem("UserName"),
          Authorization: "Bearer " + sessionStorage.getItem("authorizationToken"),
        },
        body: JSON.stringify(body),
      });
      fetch(req)
        .then((res) => res.json())
        .then((result) => {
          if (result.status == 200) {
            if(result.data._MenuConfigurationResult.length!=0)
            {
              setMenuConfig(
                result.data._MenuConfigurationResult
              );
              let Menudetails=[] //setmainMenus
              let Duplicatemenu=[]
              result.data._MenuConfigurationResult.map((data) => {
                if(Menudetails.length==0)
                {
                  Duplicatemenu.push(data.mainMenu)
                  Menudetails.push({
                  MainMenuSymbols: data.mainMenuSymbols,
                  MainMenu: data.mainMenu,
                  MainMenuId: data.mainMenuId,
                  SubMenu: data.subMenu,
                  SubMenuId: data.subMenuId,
                  PageName: data.pageName,
                  NavDatas: data.navData,
                  });
                }
                else if(Duplicatemenu.includes(data.mainMenu)==false){
                  Duplicatemenu.push(data.mainMenu)
                  Menudetails.push({
                  MainMenuSymbols: data.mainMenuSymbols,
                  MainMenu: data.mainMenu,
                  MainMenuId: data.mainMenuId,
                  SubMenu: data.subMenu,
                  SubMenuId: data.subMenuId,
                  PageName: data.pageName,
                  NavDatas: data.navData,
                  });
                }
              }); 
              // debugger;
              sessionStorage.setItem("MenuConfiguration",JSON.stringify(result.data._MenuConfigurationResult))
              sessionStorage.setItem("Menudetails",JSON.stringify(Menudetails))
              setmainMenus(Menudetails);
              // debugger;
            }
            else
            {
              window.location.reload();
            }
          }
        })
        .catch((error) => {
          console.log("ERROR: ", error);
        });
    }
    else
    {
      // debugger;
      // alert(2);
      setMenuConfig(JSON.parse(MenuConfiguration));
      let Menudetails=[]
      // debugger;
      Menudetails=sessionStorage.getItem("Menudetails");
      setmainMenus(JSON.parse(Menudetails));
    }
  };
  return (
    <>
      <div className="navbar-left" ref={modeRef}>
        <nav>
          {/* <Link to="/Home"> */}

          {/* </Link> */}
            <>
            <ul>
            <a
              title="Home"
              id="liHome"
              className={
                selectedMenu == "home" ? " titleLink active" : "titleLink"
              }
              onClick={backToHome}
            >
              <b class="material-symbols-outlined">dashboard</b>
              <span>Home</span>
            </a>
            {mainMenus.map((e,index)=>{
                // console.log(e)
                // alert(reportids + " "+reportids[0]);
                
                return ( 
                <>
                
                {e.SubMenu!="" && (
                  <a
                    title={e.MainMenu}
                    id={e.MainMenuId}
                    className={
                      getselectMenu == e.MainMenu ? " nav-toggle active"
                      : "nav-toggle"
                    }
                    // onClick={() => toggleActivities(!openActivities)}
                    // onKeyPress={() => toggleActivities(!openActivities)}
                    onClick={() => toggleActivities(e)}
                    onKeyPress={() => toggleActivities(e)}
                  >
                    <b class="material-symbols-outlined">{e.MainMenuSymbols}</b>
                    <span>{e.MainMenu}</span>
                  </a>
                )}
                {e.SubMenu=="" && (
                  <a
                    title={e.MainMenu}
                    id={e.MainMenuId}
                    className={
                      selectedMenu == getselectMenu == e.MainMenu
                        ? " nav-toggle active"
                        : "nav-toggle"
                    }
                    //onKeyPress={() => toggleConfiguration(!openConfiguration)}
                    onClick={() => NavData(e.NavDatas)}
                  >
                    <Link
                      to={"/"+e.PageName}
                      state={{
                        row,
                        selectedSubprocess,
                        nav,
                        userRoles,
                        defaultFilter,
                        assignedWorkItemDetails
                      }}
                    >
                      <b class="material-symbols-outlined">{e.MainMenuSymbols}</b>
                      <span>{e.MainMenu}</span>
                    </Link>
                  </a>
                )}
                <li>
                  <div>
                  {e.MainMenu===getselectMenu && (
                    <>
                    {MenuConfig.map((m,i)=>{
                      if(m.mainMenu==e.MainMenu && m.subMenu!="" && m.navData!="EmbeddedReports")
                      {
                        return ( 
                        <>
                          <li
                            id={m.subMenuId}
                            className="subMenu-item"
                            onClick={() => NavData(m.navData)}
                          >
                            <Link
                                to={"/"+m.pageName}
                                state={{
                                  row,
                                  selectedSubprocess,
                                  nav,
                                  userRoles,
                                  defaultFilter,
                                  assignedWorkItemDetails
                                }}
                              >
                                <span class="material-symbols-outlined submenu-icon">
                                {m.subMenuSymbols}
                                </span>
                                <span>{m.subMenu}</span>
                              </Link>
                          </li>
                        </>)
                      }
                      else if(reportids != null && reportids[0] != null && 
                        e.MainMenu=="Report" && m.navData=="EmbeddedReports")
                      {
                        return ( 
                        <>
                          <li
                            className="subMenu-item"
                            id="liEmbeddedReports"
                            onClick={() => NavData("EmbeddedReports")}
                          >
                            <Link
                              to="/EmbeddedReports"
                              state={{
                                row,
                                selectedSubprocess,
                                nav,
                                userRoles,
                                defaultFilter,
                                assignedWorkItemDetails,
                              }}
                            >
                              <span class="material-symbols-outlined submenu-icon">
                                gallery_thumbnail
                              </span>
                              Embedded Reports.
                            </Link>
                            {/* </a> */}
                          </li>
                        </>)
                      }
                    })}
                    </>
                  )}
                  </div>
                </li>
                </>
                  )
              }
            )}
          </ul>
        </>
        </nav>
        <div className="app-name">
          <span className="nav-Seperator"></span>Custom Workflow Solution{" "}
          {"   "}
        </div>

        <a className="modeToggle" onClick={onModeClick}>
          <b className="icon-chevrons-left"></b>
        </a>
      </div>
    </>
  );
};

export default Nav;
